var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGrayOpenEye = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.25C5.90909 11.25 14.0909 11.25 19 6.25M19 4.75C14.0909 -0.249999 5.90909 -0.25 1 4.75M12.4545 5.5C12.4545 6.74264 11.3556 7.75 10 7.75C8.64439 7.75 7.54545 6.74264 7.54545 5.5C7.54545 4.25736 8.64439 3.25 10 3.25C11.3556 3.25 12.4545 4.25736 12.4545 5.5Z",
    stroke: "#363A44",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGrayOpenEye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gray_open_eye.f36a3ac567d564c9ff7cd9273356f410.svg";